import ProductImportWizard from "../products/ProductImportWizard";
import SBINModal from "./SBINModal";

export default function ImportProductsModal({
  isOpen,
  onClose,
  initialSalonId,
  onComplete,
}) {
  return (
    <SBINModal
      isOpen={isOpen}
      onClose={onClose}
      title="Import Products"
      size="xxl"
    >
      <ProductImportWizard
        initialSalonId={initialSalonId}
        onComplete={onComplete}
        onClose={onClose}
      />
    </SBINModal>
  );
}
